'use strict';
const { createAddQueries } = require('../addQueries');
const {
  id,
  payerId,
  userId,
  ddaId,
} = require('./commons');

module.exports = createAddQueries({
  returnModel: {
    name: 'creditautopay',
  },
  finders: [
    id,
    payerId,
    userId,
    ddaId,
  ],
  orderBy: [
    id,
    payerId,
    userId,
  ],
});
